// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bEeg","field":"styles_field__2ng-c","fieldCol":"styles_fieldCol__3qfdH","diffCol":"styles_diffCol__10Fdn","diff":"styles_diff__UGWLv"};